module.exports = __webpack_public_path__ + "img/juliana_off.788b52d5.jpg";